// features/report/reportSlice.js
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  discrepancyReportData: null,
}

const discrepancyReportSlice = createSlice({
  name: 'discrepancyReport',
  initialState,
  reducers: {
    setDiscrepancyReportData(state, action) {
      state.discrepancyReportData = action.payload
    },
    clearDiscrepancyReportData(state) {
      state.discrepancyReportData = null
    },
  },
})

export const { setDiscrepancyReportData, clearDiscrepancyReportData } =
  discrepancyReportSlice.actions
export default discrepancyReportSlice.reducer
